<template>
  <div>
    <van-list v-model="loading" :finished="finished" @load="getComment">
      <AppComment
        :data="commentData"
        :total="info.base.comment_info.number"
        :finished="finished"
        @avatar="bindAvatar"
        @like="bindLikeComment"
        @chat="bindchatComment"
        @longpress="bindLongpress"
      ></AppComment>
    </van-list>
    <ChatComponent
      v-if="isApp"
      ref="chat"
      class="chat-fixed"
      :info="info"
      :chatInfo="chatInfo"
      @comment="bindComment"
      @collect="bindCollect"
      @like="bindLike"
      @reset="bindReset"
    />
    <delComponent v-if="showDel" @delete="bindDel" @cancel="bindCancel" />
    <van-overlay
      :show="showLike"
      :custom-style="{ background: 'rgba(255,255,255,0)' }"
    >
      <div class="wrapper" @click.stop>
        <img
          class="image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/122dfa14acdbfcd438606180206435be.png"
          alt=""
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import AppComment from './comment.vue'
import ChatComponent from './chat.vue'
import delComponent from './del.vue'
export default {
  components: {
    AppComment,
    ChatComponent,
    delComponent
  },
  props: {
    isApp: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showLike: false,
      showDel: false,
      loading: false,
      finished: false,
      page: 1,
      commentData: [],
      chatInfo: {}, //当前评论人的信息
      delData: {} //需要删除的评论
    }
  },
  created() {
    this.getParams()
    // this.chatInfo.t_unify_id = this.info.unify_id;
  },
  methods: {
    bindCancel() {
      this.showDel = false
    },
    getParams() {
      this.sign = this.$route.query.sign || ''
      this.tabType = this.$route.query.tab_type || 'weapp_group_unify'
      this.tid = this.$route.query.tid || 0
    },
    getComment(isCover) {
      let params = {
        page: this.page,
        tab_type: this.tabType,
        sign: this.$route.query.sign,
        tid: this.tid,
        pagenum: 20,
        size: 20,
        headerObj: {
          clientplatform: 3,
          clientversion: 177
        }
      }
      this.$http
        .getBaseApp('member/AppCamp/getComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.data = this.dealData(res.data.data)
            if (!res.data.data || !res.data.data.length) {
              this.finished = true
            }
            if (isCover) {
              this.commentData = res.data.data || []
            } else {
              this.commentData = this.commentData.concat(res.data.data || [])
            }
            this.page++
          } else {
            this.finished = true
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.finished = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    dealData(data) {
      data.map((item) => {
        let limit = 6
        item.open = false
        item.showMore = item.comment_list.length > limit ? true : false
        item.realCommentList = item.comment_list.slice(0, limit)
      })
      return data
    },
    /* 评论 */
    bindComment(value) {
      let parent_id =
        (this.chatInfo.parentNode && this.chatInfo.parentNode.id) || ''
      let t_unify_id = this.chatInfo.childNode
        ? this.chatInfo.childNode.unify_id
        : (this.chatInfo.parentNode && this.chatInfo.parentNode.unify_id) ||
          this.info.base.user.unify_id
      let params = {
        comment: value,
        parent_id,
        t_unify_id,
        tab_type: this.tabType,
        tid: this.tid
      }
      this.$http
        .postAppWithAppInfo('member/AppCamp/saveComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('评论成功')
            let num = this.info.base.comment_info.number + 1
            this.info.base.comment_info.number = num
            this.$refs.chat.confirmComment()
            if (parent_id) {
              this.addComment(res.data)
            } else {
              this.page = 1
              this.finished = false
              this.loading = true
              this.getComment(true)
            }
            this.$betterwe.addUpdateUgcDataEvent({
              id: this.info.detail.id,
              type: 2,
              count: num
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindAvatar(item) {
      this.$betterwe.onAppPageUrlRoute('/userDetailsPage?id=' + item.unify_id)
    },
    bindchatComment(item, item1) {
      this.chatInfo = {
        parentNode: item,
        childNode: item1
      }
      this.$refs.chat.focus()
    },
    bindLikeComment(item) {
      let flag = +!item.flag
      let params = {
        flag: flag,
        tab_type: 'weapp_comment',
        tid: item.id,
        be_liked_unify_id: item.unify_id
      }
      this.$http
        .postBaseAppNeedLogin('member/AppCamp/optionLove', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            item.flag = flag
            let num = flag ? item.zan_num + 1 : item.zan_num - 1
            item.zan_num = num >= 0 ? num : 0
            if (flag) {
              this.showLikeImage()
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindReset() {
      this.chatInfo = {}
    },
    bindLike() {
      let love = +!this.info.base.like_info.is_like
      let zannum = +this.info.base.like_info.number
      let params = {
        flag: love,
        tab_type: this.tabType,
        tid: this.tid,
        be_liked_unify_id: this.info.base.user.unify_id
      }
      this.$http
        .postBaseAppNeedLogin('member/AppCamp/optionLove', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info.base.like_info.is_like = love
            let num = love ? zannum + 1 : zannum - 1
            this.info.base.like_info.number = num >= 0 ? num : 0
            if (love) {
              this.showLikeImage()
            }
            this.$betterwe.addUpdateUgcDataEvent({
              id: this.info.detail.id,
              type: 1,
              isLike: love,
              count: num
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    showLikeImage() {
      this.showLike = true
      setTimeout(() => {
        this.showLike = false
      }, 800)
    },
    /* 收藏 */
    bindCollect() {
      let collect = +!this.info.base.collect_info.is_collect
      let collectNum = this.info.base.collect_info.number
      let params = {
        collect_type: 3,
        is_collect: collect,
        tab_type: this.tabType,
        content_id: this.tid
      }
      this.$http
        .postBaseAppNeedLogin('member/Collect/operateCollect', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info.base.collect_info.is_collect = collect
            let num = collect ? collectNum + 1 : collectNum - 1
            this.info.base.collect_info.number = num >= 0 ? num : 0
            this.$toast(collect ? '收藏成功' : '取消收藏')
            this.$betterwe.addUpdateUgcDataEvent({
              id: this.info.detail.id,
              type: 4,
              isCollect: collect,
              count: num
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //更新评论
    addComment(data) {
      if (data.parent_id) {
        for (let i = 0; i < this.commentData.length; i++) {
          if (this.commentData[i].id == data.parent_id) {
            this.commentData[i].comment_list.unshift(data)
            this.commentData[i].realCommentList.unshift(data)
            break
          }
        }
      } else {
        /* 如果不存在父级评论则直接在最前面添加 */
        this.commentData.unshift(data)
      }
    },
    delComponent(index, index1) {
      if (index !== undefined) {
        if (index1 !== undefined) {
          this.commentData[index].comment_list.splice(index1, 1)
          if (index1 < this.commentData[index].realCommentList.length) {
            this.commentData[index].realCommentList.splice(index1, 1)
          }
        } else {
          this.commentData.splice(index, 1)
        }
      }
    },
    bindLongpress(item, index, index1) {
      console.log(item, index, index1)
      if (5229 == item.unify_id) {
        this.showDel = true
        this.delData = {
          index,
          index1,
          data: item
        }
      }
    },
    bindDel() {
      this.showDel = false
      let params = {
        id: this.delData.data && this.delData.data.id
      }
      let index = this.delData.index
      let index1 = this.delData.index1
      this.$http
        .postBaseAppNeedLogin('member/AppCamp/delComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('删除成功')
            let num = this.info.base.comment_info.number - 1
            this.info.base.comment_info.number = num >= 0 ? num : 0
            this.delComponent(index, index1)
            this.$betterwe.addUpdateUgcDataEvent({
              id: this.info.detail.id,
              type: 2,
              count: num
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.chat-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .image {
    width: 120px;
    height: 120px;
    object-fit: contain;
    animation: likescale 0.4s ease;
  }
}

@keyframes likescale {
  0% {
    transform: scale(0.4);
  }

  70% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
